import React, { useEffect, useState } from 'react';

import { useAppSelector } from '@/store';
import { authStore } from '@/store/auth';
import { AccountMenu } from '../Presentation';
import { pages } from '@/settings/pages';
import { Loading } from '@/components/utils/Loading';
import { useCheckAuthorizationFreshness } from '@/hooks/useCheckAuthorizationFreshness';

export const AccountMenuContainer: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  const checkAuthorizationFreshness = useCheckAuthorizationFreshness(
    setIsLoading,
    pages.account.index,
  );

  useEffect(() => {
    checkAuthorizationFreshness();
  }, [checkAuthorizationFreshness]);

  const admin = useAppSelector(authStore.selectors.meSelector);
  return isLoading ? <Loading /> : <AccountMenu admin={admin} />;
};
